import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  id: "lotto-wrapper",
  class: "contents-wrapper"
}
const _hoisted_2 = { id: "lotto-recent" }
const _hoisted_3 = { id: "this-round" }
const _hoisted_4 = { class: "description" }
const _hoisted_5 = { class: "round-info" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "label" }, "다음 회차", -1)
const _hoisted_7 = { class: "game-number" }
const _hoisted_8 = { class: "drw-date" }
const _hoisted_9 = { class: "buy-list-area" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "progress-buy-title" }, "구매내역", -1)
const _hoisted_11 = { id: "past-round" }
const _hoisted_12 = { class: "game-buy-list" }
const _hoisted_13 = {
  key: 0,
  class: "game-buy-title"
}
const _hoisted_14 = {
  key: 1,
  class: "game-buy-title-no"
}
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", null, "구매내역 없음", -1)
const _hoisted_16 = [
  _hoisted_15
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LottoBuyGame = _resolveComponent("LottoBuyGame")!
  const _component_LottoResult = _resolveComponent("LottoResult")!

  return (_openBlock(), _createElementBlock("article", _hoisted_1, [
    _createElementVNode("button", {
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.getBuySummary && _ctx.getBuySummary(...args)))
    }, "조회"),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _hoisted_6,
            _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.res.drwNo), 1)
          ]),
          _createElementVNode("div", _hoisted_8, " 추첨일 " + _toDisplayString(_ctx.getDateFormat(_ctx.res.drwNoDate, "yyyy년 MM월 dd일 ")) + " 8시 35분 ", 1)
        ]),
        _createElementVNode("div", _hoisted_9, [
          _hoisted_10,
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.res.progressList, (progress) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "progress-item",
              key: progress.drwNo
            }, [
              _createVNode(_component_LottoBuyGame, { lottoGame: progress }, null, 8, ["lottoGame"])
            ]))
          }), 128))
        ])
      ]),
      _createElementVNode("div", _hoisted_11, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.res.resultList, (game) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "result-item",
            key: game.result.drwNo
          }, [
            _createVNode(_component_LottoResult, {
              lottoResult: game.result
            }, null, 8, ["lottoResult"]),
            _createElementVNode("div", _hoisted_12, [
              (game.gameBuyList.length > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_13, " 구매내역 "))
                : (_openBlock(), _createElementBlock("div", _hoisted_14, _hoisted_16)),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(game.gameBuyList, (gameBuy) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "game-buy-item",
                  key: gameBuy.drwNo
                }, [
                  _createVNode(_component_LottoBuyGame, { lottoGame: gameBuy }, null, 8, ["lottoGame"])
                ]))
              }), 128))
            ])
          ]))
        }), 128))
      ])
    ])
  ]))
}